import querySelectorAll from './querySelectorAll';
import {dataLayerPopup} from './dataLayers';

const KEYCODE_ESCAPE = 27;

const CLASSES = {
    HOOK: 'js-modal-handle',
    MODAL: {
        DEFAULT: 'modal',
        VISIBLE: 'modal--visible',
        AUTO_OPEN: 'modal--autoopen',
        CLOSE_BUTTON: 'js-modal-close'
    },
    BACKDROP: {
        VISIBLE: 'modal__backdrop--visible',
        DEFAULT: 'modal__backdrop'
    }
};

let isHidden = true;
let backdrop;

const handles = querySelectorAll(`.${CLASSES.HOOK}`);
const autoOpenModals = querySelectorAll(`.${CLASSES.MODAL.AUTO_OPEN}`);

export default function modals() {
    handles.forEach((handle) => {
        handle.addEventListener('click', clickHandler);
    });

    renderBackdrop();

    autoOpenModals.forEach((handle) => {
        modalHandler(handle);
    });
}

function clickHandler(e) {
    e.preventDefault();

    const element = e.currentTarget;
    const targetModal = document.querySelector(element.dataset.target);
    const locationModal = element.dataset.location;
    const targetModalId = targetModal.id;
    const modalBtnUrl = element.dataset.url;

    if (locationModal !== undefined) {
        targetModal.dataset.location = locationModal;
    }

    modalHandler(targetModal);

    if (!targetModal.classList.contains('js-video-modal')) { // not for video modals, video has its own push
        dataLayerPopup(targetModalId);
    }

    if (modalBtnUrl) {
        insertUrl(targetModal, modalBtnUrl);
    }
}

let handleBackdropClick;

export function modalHandler(targetModal) {
    const closeBtn = targetModal.querySelectorAll(`.${CLASSES.MODAL.CLOSE_BUTTON}`);

    if (!handleBackdropClick) {
        handleBackdropClick = () => {
            modalHandler(targetModal);
        };
    }

    if (isHidden) {
        targetModal.classList.add(CLASSES.MODAL.VISIBLE);
        backdrop.node.classList.add(CLASSES.BACKDROP.VISIBLE);

        window.addEventListener('keyup', keyboardHandler);
        backdrop.node.addEventListener('click', handleBackdropClick);
        closeBtn.forEach((each) => {
            each.addEventListener('click', handleBackdropClick);
        });

        document.getElementById('html').classList.add('html--modal--open'); // needed on html instead of body for input in modal bug on iOS for iPhone (not iPad)

        isHidden = false;
    } else {
        targetModal.classList.remove(CLASSES.MODAL.VISIBLE);
        backdrop.node.classList.remove(CLASSES.BACKDROP.VISIBLE);

        window.removeEventListener('keyup', keyboardHandler);
        backdrop.node.removeEventListener('click', handleBackdropClick);
        closeBtn.forEach((each) => {
            each.removeEventListener('click', handleBackdropClick);
        });

        document.getElementById('html').classList.remove('html--modal--open'); // needed on html instead of body for input in modal bug on iOS for iPhone (not iPad)

        isHidden = true;
        handleBackdropClick = undefined;

        // Remove video from modal content when closing modal
        if (targetModal.classList.contains('js-video-modal')) {
            const videoContainer = targetModal.getElementsByClassName('js-videolink-container')[0];

            videoContainer.innerHTML = '';
        }
    }
}

export function renderBackdrop() {
    const backdropNode = document.createElement('div');
    backdropNode.setAttribute('class', `${CLASSES.BACKDROP.DEFAULT}`);

    document.body.appendChild(backdropNode);

    backdrop = {
        node: backdropNode,
        namespace: 'BACKDROP'
    };
}

function insertUrl(targetModal, modalBtnUrl) {
    targetModal.querySelector('.js-insert-url').href = modalBtnUrl;
}

function keyboardHandler(e, targetModal) {
    if (e.keyCode === KEYCODE_ESCAPE) {
        modalHandler(targetModal);
    }
}




// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/Modals.js